import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './http-services/authentication.service';
import { UserService } from './http-services/user.service';

@Injectable({
  providedIn: 'root'
})
export class SetupGuardService implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userService.getUserStorage().initialSetup === true) {
      return true;
    }
    this.router.navigate(["/setup"])
    return false;

  }
}

